import React, { useCallback } from "react";
import styled from "styled-components";
import { ArrowNext } from "assets/images/ArrowNext";
import { ArrowPrev } from "assets/images/ArrowPrev";
import ReactPaginate from "react-paginate";

export interface ActivationPaginationProps {
  maxPage: number;
  pageIndex: number;
  loading: boolean;
  onPageChange: (selectedItem: { selected: number }) => void;
}

const ActivationPagination: React.FC<ActivationPaginationProps> = ({
  onPageChange,
  maxPage,
  pageIndex,
  loading,
}: ActivationPaginationProps): JSX.Element => {
  const onChange = useCallback(
    async (e: { selected: number }) => {
      onPageChange({ selected: e.selected });
      // return false; することで、内部状態によるselectedの移動を禁止し、selectedはforcePageによってのみ変更されるよう経路を限定する
      return false;
    },
    [onPageChange]
  );

  return (
    <PaginateWrap>
      <PaginateNav>
        <Paginate
          marginPagesDisplayed={1}
          pageRangeDisplayed={2}
          pageCount={maxPage}
          forcePage={pageIndex}
          onPageChange={onChange}
          suspend={loading}
          previousLabel={
            <>
              <ArrowPrev />
              Prev
            </>
          }
          nextLabel={
            <>
              Next
              <ArrowNext />
            </>
          }
        />
      </PaginateNav>
    </PaginateWrap>
  );
};

export default ActivationPagination;

const PaginateWrap = styled.div`
  margin-bottom: 3rem;
  text-align: center;
`;

const PaginateNav = styled.nav`
  display: inline-block;
  a svg {
    margin: 0 0.5rem;
    width: 0.5rem;
    vertical-align: middle;
  }
`;

const Paginate = styled(ReactPaginate)<{ suspend: boolean }>`
  display: flex;
  flex-direction: row;
  padding: 0 5rem;
  li a {
    text-decoration: ${(props) => (props.suspend ? "none" : "underline")};
    display: inline-block;
    padding: 0.5rem;
    margin-right: 0.5rem;
    cursor: ${(props) => (props.suspend ? "default" : "pointer")};
    pointer-events: ${(props) => (props.suspend ? "none" : "auto")};
    color: #005eb8;
    svg {
      fill: #005eb8;
    }
  }

  li.selected a {
    cursor: default;
    color: #999999;
    text-decoration: none;
    pointer-events: none;
    svg {
      fill: #999999;
    }
  }

  li.disabled a {
    cursor: default;
    color: #999999;
    text-decoration: none;
    pointer-events: none;
    svg {
      fill: #999999;
    }
  }
`;
